import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { readableDeviceName } from '@iotv/core-services';
import { getSpecificEdgeTypeId } from '@iotv/datamodel-core';
import { DeviceTypes, UNCLASSIFIED_DOMAIN } from '@iotv/iotv-v3-types';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { AlertErrors } from '../../../ErrorHandling/ErrorBoundaryFallback';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '../../../types/AppTypes';
import { DefaultStepTypeFolderClickWrapper } from '../../../v2/components/generic/ObjectTree';
import { ObjectTree } from '../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
import { RoutingLabelClickWrapper } from '../clickWrappers/RoutingLabelClickWrapper';
const debug = process.env.REACT_APP_DEBUG && false;
const GROUPER_TYPE = 'Group';
/** @deprecated */
export const getContainedTypeLabelWrapper = (entityTypeId) => (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props, element: _jsx(_Fragment, { children: "Entity Groups" }), support: entityTypeId }));
/** Finds supported groups from a User Group, then iteratively goes down their sub groups */
export const VisibleDeviceGroupsTree = ({ userGroup, deviceType, nodeEdgeMapper, transactionFunctions, label, uniqueTreeId, domain, }) => {
    const deviceTypeName = DeviceTypes[deviceType];
    const readableName = readableDeviceName(deviceType);
    const nodeFilters = [
        { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Device' }] },
    ];
    if (domain !== UNCLASSIFIED_DOMAIN)
        nodeFilters.push({
            setOperation: LogicalOperatorType.AND,
            filters: [
                { key: 'domain', predicate: ComparisonType.EQUALS, value: domain },
                { key: 'subSupportedType', predicate: ComparisonType.EQUALS, value: deviceType },
            ],
        });
    return (_jsx(TreeItem, { itemId: `${domain}-${label}-${uniqueTreeId}-visible-${deviceTypeName}-group`,
        label: label ?? readableName,
        children: (_jsx(ObjectTree, { uniqueTreeId,
            nodeEdgeMapper,
            // ADH: Bit of a hack, I know. We need a better mechanism for providing a context object to the navigation context rather than assuming it's context customer
            contextObjects: [userGroup],
            queryPaths: [
                {
                    stepQuery: {
                        objectTypeId: GROUPER_TYPE,
                        adjacencyType: AdjacentType.CHILD,
                        edgeTypeId: getSpecificEdgeTypeId('Group', 'Group', 'group_allows_group'),
                        nodeFilters,
                    },
                    thisStepTypeFolderClickWrapper: undefined,
                    renderTypeFolder: false,
                    nextSteps: getSingleTypeRecursivePath({
                        groupObjectType: GROUPER_TYPE,
                        containedObjectType: 'Device',
                        ContainedTypeLabelWrapper: getContainedTypeLabelWrapper('Device'),
                        ContainedTypeInstanceClickWrapper: RoutingLabelClickWrapper,
                    }),
                },
            ],
            transactionFunctions,
            onTypeFolderClickWrapper: undefined /*CustFolderClickWrapper*/,
            hideTopStep: true,
            maintree_rightclick: true }, `${domain}-visible-${deviceTypeName}`)) }, `${domain}-visible-${deviceTypeName}-group`));
};
export const SpecificDeviceVisibleGroupTree = (deviceType, domain, uniqueTreeId) => {
    return ({ applicationData, transactionFunctions, user }) => {
        const key = `${deviceType}_${domain}_${uniqueTreeId}`;
        const parents = user ? applicationData.getParentNodes(user) : [];
        const userGroups = parents.filter((n) => n.type === 'Group');
        const userGroup = userGroups.at(0);
        debug && console.log('Specific Device Visible Group Tree', 'user group', parents, userGroup);
        return (_jsx(AlertErrors, { children: userGroup ? (_jsx(VisibleDeviceGroupsTree, { userGroup, deviceType, nodeEdgeMapper: applicationData, transactionFunctions, uniqueTreeId, domain }, key)) : (_jsx(NavigationSkeleton, {}, key)) }, key + '_errors'));
    };
};
